var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0625 1.125H6.90833C8.12178 1.125 8.7285 1.125 9.19198 1.36115C9.59966 1.56888 9.93112 1.90034 10.1388 2.30802C10.375 2.7715 10.375 3.37822 10.375 4.59167V8.4375M2.35833 10.875H6.74583C7.35256 10.875 7.65592 10.875 7.88766 10.7569C8.0915 10.6531 8.25723 10.4873 8.36109 10.2835C8.47917 10.0518 8.47917 9.74839 8.47917 9.14167V4.75417C8.47917 4.14744 8.47917 3.84408 8.36109 3.61234C8.25723 3.4085 8.0915 3.24277 7.88766 3.13891C7.65592 3.02083 7.35256 3.02083 6.74583 3.02083H2.35833C1.75161 3.02083 1.44825 3.02083 1.21651 3.13891C1.01267 3.24277 0.846939 3.4085 0.743076 3.61234C0.625 3.84408 0.625 4.14744 0.625 4.75417V9.14167C0.625 9.74839 0.625 10.0518 0.743076 10.2835C0.846939 10.4873 1.01267 10.6531 1.21651 10.7569C1.44825 10.875 1.75161 10.875 2.35833 10.875Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/copy2.15abbeca770d3cbe51ccd9ec3810d67d.svg";
export { ForwardRef as ReactComponent };